import { coachesService } from '../services';

export const coaches = {
    namespaced: true,
    state: {
        all: {},
        selected: {},
        grammMetrics: {},
        default: {}
    },
    actions: {
        getAll({ commit }, id) {
            commit('getAllRequest');

            return new Promise((resolve, reject) => {
                coachesService.getAll(id)
                .then(
                    payload => {
                        commit('getAllSuccess', payload)
                        resolve(payload)
                    }, 
                    error => {
                        commit('getAllFailure', error)
                        reject(error)
                    } 
                )
            });
            
        },       

        getSingle({ commit }, id) {
            commit('getRequest');

            return new Promise((resolve, reject) => {
                coachesService.getSingle(id)
                .then(
                    payload => {
                        commit('getSuccess', payload)
                        resolve(payload)
                    }, 
                    error => {
                        commit('getFailure', error)
                        reject(error)
                    } 
                )
            });            
        },

        delete({
            commit
        }, dto) {
            commit('defaultRequest');

            return new Promise((resolve, reject) => {
                coachesService.deleteExisting(dto)
                    .then(
                        payload => {
                            commit('defaultRequest', payload);
                            resolve(payload)
                        },
                        error => {
                            commit('defaultRequest', error);
                            reject(error)
                        }
                    );
            })
        },

        update({
            commit
        }, dto) {
            commit('defaultRequest');

            return new Promise((resolve, reject) => {
                coachesService.updateExisting(dto)
                    .then(
                        payload => {
                            commit('defaultRequest', payload);
                            resolve(payload)
                        },
                        error => {
                            commit('defaultRequest', error);
                            reject(error)
                        }
                    );
            })
        },

        lockRequest({ //Lock or Unlock
            commit
        }, dto) {
            commit('defaultRequest');

            return new Promise((resolve, reject) => {
                coachesService.lockCoach(dto)
                    .then(
                        payload => {
                            commit('defaultRequest', payload);
                            resolve(payload)
                        },
                        error => {
                            commit('defaultRequest', error);
                            reject(error)
                        }
                    );
            })
        },

        activateRequest({ //Freischalten (Nicht entsperren)
            commit
        }, dto) {
            commit('defaultRequest');

            return new Promise((resolve, reject) => {
                coachesService.activateCoach(dto)
                    .then(
                        payload => {
                            commit('defaultRequest', payload);
                            resolve(payload)
                        },
                        error => {
                            commit('defaultRequest', error);
                            reject(error)
                        }
                    );
            })
        },

        create({
            commit
        }, dto) {
            commit('defaultRequest');

            return new Promise((resolve, reject) => {
                coachesService.createNew(dto)
                    .then(
                        payload => {
                            commit('defaultSuccess', payload);
                            resolve(payload)
                        },
                        error => {
                            commit('defaultFailure', error);
                            reject(error)
                        }
                    );
            })
        },
    },
    mutations: {

        defaultRequest(state) {
            state.default = {
                loading: true
            }; 
        },
        defaultSuccess(state, payload) {
            state.default = {
                item: payload,
                loading: false
            }; 
        },
        defaultFailure(state, error) {
            state.default = {
                error,
                loading: false
            }; 
        },

        getRequest(state) {
            state.selected = { loading: true };
        },
        getSuccess(state, payload) {
            state.selected = { item: payload };
        },
        getFailure(state, error) {
            state.selected = { error };
        },
        getAllRequest(state) {
            state.all = { loading: true };
        },
        getAllSuccess(state, users) {
            state.all = { items: users };
        },
        getAllFailure(state, error) {
            state.all = { error };
        },
    }
}